import { getImageFromDB } from "../../../utils/indexedDB";

export const loadImagesFromDB = async (images, imageCache) => {
  let newImageElements = new Map();
  let missingImageIds = [];

  for (const img of images) {
    if (!imageCache.current.has(img.id)) {
      const imageBlob = await getImageFromDB('uploadedImages', img.id);

      if (imageBlob) {
        const imgElement = new Image();
        imgElement.src = URL.createObjectURL(imageBlob);
        await new Promise((resolve) => (imgElement.onload = resolve));
        newImageElements.set(img.id, imgElement);
        imageCache.current.set(img.id, imgElement);
      } else {
        missingImageIds.push(img.id);
      }
    }
  }

  return newImageElements;
};
